module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ticket-view/modals/resolve-approval-request-modal/resolve-approval-request-modal.component.css
// module id = ./src/app/ticket-view/modals/resolve-approval-request-modal/resolve-approval-request-modal.component.css
// module chunks = main